import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

export const Post = styled.div`
  p {
    color: #fff;
    font-family: "Made Light", sans-serif;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0.3px;
    margin: 16px 0;
    strong {
      font-weight: 700;
    }
    @media (min-width: 768px) {
      font-size: 20px;
      line-height: 1.6;
      letter-spacing: 0.2px;
    }
  }

  h2 {
    font-size: 24px;
    line-height: 1.25;
    letter-spacing: 0.2px;
    margin: 32px 0 16px;
    @media (min-width: 768px) {
      font-size: 30px;
      line-height: 1.33;
      letter-spacing: 0.4px;
    }
  }

  h3 {
    font-size: 20px;
    line-height: 1.4;
    letter-spacing: 0.2px;
    margin: 16px 0;
    @media (min-width: 768px) {
      font-size: 24px;
      line-height: 1.5;
      letter-spacing: 0.3px;
    }
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Made Medium", sans-serif;
    color: #fff;
    margin: 32px 0 16px;
  }

  h4,
  h5,
  h6 {
    font-size: 20px;
    line-height: 32px;
  }

  a {
    color: #f9d6c1;
    text-decoration: underline;
    display: inline;
  }

  blockquote {
    margin: 3.5rem 0 2rem;
    position: relative;
    background-color: #151515;
    border-radius: 4px;
    padding: 16px 16px 16px 22px;
    & p {
      margin-top: 0;
      margin-bottom: 0;
      &:last-child {
        margin-top: 24px;
        font-family: "Made Medium", sans-serif;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.3px;
        @media (min-width: 768px) {
          text-align: right;
          font-size: 24px;
          line-height: 36px;
          letter-spacing: 0.3px;
        }
      }
    }
    @media (min-width: 768px) {
      padding: 30px 40px;
    }
    &::before {
      content: "";
      position: absolute;
      width: 4px;
      height: 100%;
      border-radius: 4px 0 0 4px;
      top: 0;
      left: 0;
      background: linear-gradient(to bottom, #f9d6c1, #c39779);
      @media (min-width: 768px) {
        width: 8px;
      }
    }
  }
  ul,
  ol {
    list-style: none;
    padding-left: 36px;
  }
  ul li,
  ol li {
    margin-top: 12px;
    font-family: "Made Light", sans-serif;
    position: relative;
    font-size: 18px;
    line-height: 1.44;
    letter-spacing: 0.3px;
    @media (min-width: 768px) {
      font-size: 20px;
      line-height: 1.6;
      letter-spacing: 0.2px;
    }
  }
  ol {
    counter-reset: li;
  }
  ol li {
    counter-increment: li;
    &::before {
      position: absolute;
      left: 0;
      top: 0;
      transform: translateX(-20px);
      content: counter(li) ".";
      color: #f9d6c1;
    }
  }
  ul li {
    &::before {
      position: absolute;
      left: 0;
      top: -4px;
      transform: translateX(-20px);
      content: "• ";
      color: #ddd;
      font-weight: 900;
      font-size: 23px;
    }
  }
  & .gatsby-resp-image-wrapper {
    margin: 24px auto;
  }
  & .gatsby-resp-image-image {
    border-radius: 8px;
  }
`

const Content = ({ content, className }) => {
  return (
    <Post
      className={[className, "blog-post-wrapper"].join(" ")}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}

export const HTMLContent = ({ content, className }) => (
  <Post className={className}>{content}</Post>
)

Content.propTypes = {
  content: PropTypes.node,
  className: PropTypes.string,
}
Content.defaultProps = {
  content: "",
  className: null,
}

HTMLContent.propTypes = Content.propTypes

export default Content
